import React from "react";
import { Helmet } from "react-helmet";
import { Layout } from "../components/common";
import { MetaData } from "../components/common/meta";
import { Pane, Button, ArrowLeftIcon } from "evergreen-ui";
import { Link } from "../components/common";
import { walletNameCombinations } from "../utils/createHardwareWalletPages";
import { currentMonth, currentMonthShort, currentYear } from "../utils/constants";

const AllWalletCombinationsPage = ({ location }) => {
    const title = `All Hardware Wallet & Cold Wallet Comparisons of ${currentMonthShort} ${currentYear}`;
    const excerpt = `Complete list of all hardware wallet & cold wallet comparisons of ${currentMonth} ${currentYear}. Compare Trezor, Ledger, and Blockstream crypto hardware wallets side by side.`;
    const description = excerpt;

    const page = { meta_title: title, title, excerpt, description };
    const newData = { ghostPage: page };
    const metaImage =
        "https://www.cefirates.com/images/hardware-wallets/best-crypto-hardware-cold-wallets.png";

    return (
        <>
            <MetaData
                data={newData}
                location={location}
                type="website"
                image={metaImage}
            />
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <Layout location={location}>
                <div className="container">
                    <article className="content">
                        <Pane className="content-title image-heading-container">
                            <h1 className="image-heading">{title}</h1>
                        </Pane>
                        <section className="content-body load-external-scripts post-card-excerpt">
                            {description}
                        </section>

                        <section className="content-body">
                            <Pane display="flex" flexWrap="wrap">
                                {walletNameCombinations.map((combination) => (
                                    <Pane
                                        display="flex"
                                        width="50%"
                                        padding={8}
                                        minWidth={300}
                                        flexDirection="column"
                                        marginX="auto"
                                    >
                                        <Link to={`/${combination.slug}/`}>
                                            <Button
                                                size="large"
                                                appearance="secondary"
                                                width="100%"
                                                height="auto"
                                                paddingY={12}
                                                whiteSpace="normal"
                                                wordWrap="break-word"
                                                lineHeight="initial"
                                            >
                                                {combination.title}
                                            </Button>
                                        </Link>
                                    </Pane>
                                ))}
                            </Pane>

                            <Pane
                                display="flex"
                                justifyContent="center"
                                marginTop={32}
                            >
                                <Link to="/best-hardware-wallets/">
                                    <Button
                                        size="large"
                                        appearance="primary"
                                        iconBefore={ArrowLeftIcon}
                                    >
                                        Best Hardware / Cold Wallets
                                    </Button>
                                </Link>
                            </Pane>
                        </section>
                    </article>
                </div>
            </Layout>
        </>
    );
};

export default AllWalletCombinationsPage;
